import type { Authenticator } from '../types';

import type MsalRedirectAuthenticator from './MsalRedirectAuthenticator';

type IsMsalRedirectAuthenticator = (authenticator: Authenticator) => authenticator is MsalRedirectAuthenticator;
export const isMsalRedirectAuthenticator: IsMsalRedirectAuthenticator = (
  authenticator: Authenticator
): authenticator is MsalRedirectAuthenticator =>
  (authenticator as MsalRedirectAuthenticator).initializeCurrentAccount !== undefined;
